
import React from "react";
import ContactForm from "@/components/contact/ContactForm";
import ContactInfoSection from "@/components/contact/ContactInfoSection";
import OtherResourcesSection from "@/components/contact/OtherResourcesSection";
import { NewsletterSection } from "@/components/home/NewsletterSection";
import { useToastWrapper } from "@/hooks/useToastWrapper";
import EnhancedSeoMetadataComponent from "@/components/common/EnhancedSeoMetadata";
import { getEnhancedSeoDataForRoute } from "@/utils/enhancedSeoUtils";

const YhteydenottoPage = () => {
  const { toast } = useToastWrapper();
  const seoData = getEnhancedSeoDataForRoute("/yhteydenotto");

  return (
    <>
      <EnhancedSeoMetadataComponent
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonicalUrl="https://lainasampo.fi/yhteydenotto"
        schema={seoData.schema}
      />
      
      <div className="bg-blue-50 min-h-screen py-8 md:py-12">
        <div className="container mx-auto max-w-7xl px-4 md:px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-blue-800 mb-2">Ota yhteyttä</h1>
          <p className="text-lg md:text-xl text-blue-600 mb-8 md:mb-12">Olemme täällä auttaaksemme sinua kaikissa lainoihin liittyvissä kysymyksissä.</p>
          
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
            {/* Contact form section - smaller width, takes 5/12 of the space on large screens */}
            <div className="lg:col-span-5 space-y-8">
              <ContactForm />
            </div>
            
            {/* Right sections - take 7/12 of the space on large screens */}
            <div className="lg:col-span-7 space-y-8">
              <ContactInfoSection />
              
              {/* Newsletter subscription integrated in between */}
              <div className="bg-white rounded-xl shadow-sm border border-blue-100 p-6 md:p-8">
                <NewsletterSection hideTitle={true} customTitle="Liity postituslistalle" />
              </div>
              
              <OtherResourcesSection />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default YhteydenottoPage;
